<template>
  <div class="module2Add detailsPage">
    <div class="optionArea u-cf">
      <div class="u-fl">
        <el-button type="primary" @click.stop="onSubmit" :loading="confirmBtnDis">提交</el-button>
        <el-button @click.stop="onBack" :disabled="confirmBtnDis">返回</el-button>
      </div>
      <div class="u-fr">
      </div>
    </div>
    
    <div class="module2Add_con detailsPage_con u-border">
      <!--表单项-->
      <div class="module2Add_form detailsPage_form">
        <el-form
          ref="form"
          label-position="right"
          label-width="110px"
          :model="form"
          :rules="formRules">
          <el-row>
            <el-col :span="6">
              <el-form-item label="xxx编码：" prop="code" :rules="formRules.required">
                <el-input v-model.trim="form.code"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="xxx名称：" prop="name" :rules="formRules.required">
                <el-input v-model.trim="form.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { isNumber } from '@/utils/validate';
  // 接口
  import { test, testByGet } from '@/api/common';
  
  // 初始化表单
  function getInitForm () {
    return {
      code: '',
      name: ''
    };
  }
  
  // 自定义验证规则
  const validators = {
    isNumber: function (rule, value, callback) {
      if (value && !isNumber(value)) {
        callback(new Error('请输入数字'));
      } else {
        callback();
      }
    }
  };
  
  export default {
    name: 'module2Add',
    inject: ['myMessage', 'reload'],
    data () {
      return {
        confirmBtnDis: false,
        id: '',
        optionType: 'add', // 默认是新增
        optionTitle: '新增', // 默认是新增
        detailsData: {},
        form: getInitForm(),
        formRules: {
          required: [
            { required: true, message: '不能为空' }
          ],
          isNumber: [
            { trigger: ['change', 'blur'], validator: validators.isNumber }
          ]
        }
      };
    },
    methods: {
      requestDetails () {
        testByGet(this.id)
          .then(res => {
            this.handleInitData(res.data);
          })
          .catch(() => {
            this.myMessage.megError('获取详情信息失败');
          });
      },
      
      requestUpdateData () {
        this.confirmBtnDis = true;
        
        // 请求接口 默认是新增的
        let requestUrl = test;
        if (this.optionType === 'edit') {
          // 修改的接口
          requestUrl = test;
        }
        
        requestUrl(this.handleFormData())
          .then(resData => {
            this.myMessage.megSuc(this.optionTitle + '成功');
            if (this.optionType === 'edit') {
              this.reload();
            } else {
              const paths = this.$route.path.split('/');
              paths.pop();
              this.$router.push({ path: paths.join('/') });
            }
          })
          .catch(() => {
            this.myMessage.megError(this.optionTitle + '失败');
          })
          .finally(() => {
            this.confirmBtnDis = false;
          });
      },
      
      handleInitData (data) {
        this.detailsData = { ...data };
        Object.keys(this.form).forEach(key => {
          this.form[key] = data[key];
        });
      },
      
      // 处理请求数据
      handleFormData () {
        const requestData = { ...this.form };
        if (this.optionType === 'edit') {
          requestData.id = this.id;
        }
        
        return requestData;
      },
      
      // 保存
      onSubmit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.requestUpdateData();
          }
        });
      },
      
      // 返回
      onBack () {
        this.$router.back();
      },
      
      // 页面初始化处理
      handlePageInit () {
        if (this.$route.query.id) {
          // 修改
          this.id = this.$route.query.id;
          this.optionType = 'edit';
          this.optionTitle = '修改';
          this.requestDetails();
        } else {
          // 新增
        }
      }
    },
    created () {
      this.handlePageInit();
    }
  };
</script>

<style lang="scss">
  .module2Add {
  
  }
</style>
